import { render, staticRenderFns } from "./CoventryPerson.vue?vue&type=template&id=5a3272f4&"
import script from "./CoventryPerson.vue?vue&type=script&lang=js&"
export * from "./CoventryPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports